module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "device-map"
  }, [_c('el-row', {
    staticClass: "warp"
  }, [_c('el-col', {
    staticClass: "warp-breadcrum",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('b', [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("设备管理")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/device/device'
      }
    }
  }, [_vm._v("设备状态")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("地图展示")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('baidu-map', {
    staticClass: "bm-view",
    attrs: {
      "ak": "68gqtbhlTp0oWG4oywdD5YG0bG5hPq4C",
      "center": _vm.mapConfig.center,
      "zoom": _vm.mapConfig.zoom,
      "scroll-wheel-zoom": _vm.mapConfig.scrollWheelZoom,
      "auto-resize": _vm.mapConfig.autoResize
    },
    on: {
      "ready": _vm.handler
    }
  }, [_vm._l((_vm.markerDatas), function(item, index) {
    return [_c('baidu-marker', {
      key: index,
      attrs: {
        "position": {
          lng: item.deviceLongitude,
          lat: item.deviceLatitude
        },
        "icon": {
          url: require('../../assets/images/loc_red.png'),
          size: {
            width: 30,
            height: 30
          }
        }
      },
      on: {
        "click": function($event) {
          return _vm.handleMarkerClick($event, item)
        }
      }
    }, [(item.deviceCount > 1) ? _c('baidu-label', {
      attrs: {
        "content": item.deviceCount + '台',
        "labelStyle": {
          color: 'black',
          fontSize: '12px'
        },
        "offset": {
          width: 25,
          height: -10
        }
      }
    }) : _vm._e()], 1)]
  }), _vm._v(" "), _c('baidu-info-window', {
    attrs: {
      "position": _vm.infoWindow.position,
      "title": _vm.infoWindow.title,
      "show": _vm.infoWindow.show
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.infoWindow.deviceDatas), function(item, index) {
    return [_c('div', {
      key: index,
      staticClass: "device-item"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('label', [(item.deviceWarState === 1) ? _c('i', {
      staticClass: "fa fa-circle",
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('label', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("在线")])]) : (item.deviceWarState === 2) ? _c('i', {
      staticClass: "fa fa-circle",
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('label', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("离线")])]) : (item.deviceWarState === 0) ? _c('i', {
      staticClass: "fa fa-circle",
      staticStyle: {
        "color": "yellow"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('label', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("未知")])]) : _vm._e()]), _vm._v(" "), _c('label', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.deviceCode))]), _vm._v(" "), _c('label', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.formatterCategory(item.deviceCategoryId)))])]), _vm._v(" "), _c('div', {
      staticClass: "address"
    }, [_vm._v(_vm._s(item.provinceName + item.cityName + item.districtName + item.addressDetail + item.devicePosition))])])]
  })], 2)])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d82f732"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/device/deviceMap.vue
// module id = 1163
// module chunks = 2